(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lv-eu-guarantee"] && !Shopify.designMode) return;
  try {
    let euGuaranteeTrigger;
  let euGuaranteeDrawer;
  let euGuaranteeWasLocked;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-eu-guarantee-open]');
    const dialog = document.getElementById('LvEuGuarantee');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (trigger) {
      event.preventDefault();
      euGuaranteeTrigger = trigger;
      euGuaranteeDrawer = trigger.closest('cart-drawer, cart-notification');
      if (euGuaranteeDrawer && typeof removeTrapFocus === 'function') removeTrapFocus();
      if (euGuaranteeDrawer?.onBodyClick) document.body.removeEventListener('click', euGuaranteeDrawer.onBodyClick);
      const template = dialog.querySelector('template');
      if (template) { template.replaceWith(template.content.cloneNode(true)); }
      euGuaranteeWasLocked = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      dialog.dataset.zoomed = 'false';
      const zoomButton = dialog.querySelector('[data-eu-guarantee-zoom]');
      zoomButton.setAttribute('aria-pressed', 'false');
      zoomButton.textContent = zoomButton.dataset.labelZoom;
      dialog.showModal();
      dialog.querySelector('.lv-eu-guarantee-scroll').scrollTo(0, 0);
    } else if (event.target.closest('[data-eu-guarantee-zoom]')) {
      const zoomButton = event.target.closest('[data-eu-guarantee-zoom]');
      const zoomed = dialog.dataset.zoomed !== 'true';
      dialog.dataset.zoomed = String(zoomed);
      zoomButton.setAttribute('aria-pressed', String(zoomed));
      zoomButton.textContent = zoomed ? zoomButton.dataset.labelFit : zoomButton.dataset.labelZoom;
      dialog.querySelector('.lv-eu-guarantee-scroll').scrollTo(0, 0);
    } else if (event.target.closest('[data-eu-guarantee-close]') || event.target === dialog) {
      dialog.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.id !== 'LvEuGuarantee') return;
    if (!euGuaranteeWasLocked) document.body.classList.remove('overflow-hidden');
    if (euGuaranteeDrawer && (euGuaranteeDrawer.classList.contains('active') || euGuaranteeDrawer.querySelector('#cart-notification.active')) && typeof trapFocus === 'function') {
      trapFocus(euGuaranteeDrawer.querySelector('#CartDrawer, #cart-notification'), euGuaranteeTrigger);
      if (euGuaranteeDrawer.onBodyClick) document.body.addEventListener('click', euGuaranteeDrawer.onBodyClick);
    } else { euGuaranteeTrigger?.focus(); }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
